// import React from "react";

// import { AW22 } from "../../../../js/database/database-aw22.js";

// import TopMenuProducts from "../../../../components/topmenuproducts";
// import SwiperInit from "../../../../components/SwiperInit";
// import InfoItem from "../../../../components/infoItem";
// import Loader from "../../../../components/loader";
// import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
// import SizeChart from "../../../../components/sizeChart.js";

// class DropShoulderPUCoat extends React.Component {
//   render() {
//     return (
//       <div>
//         <Loader />
//         <TopMenuProducts name={AW22.jackets.DropShoulderPUCoat.itemName} />

//         <InfoItem
//           price={AW22.jackets.DropShoulderPUCoat.itemPrice}
//           fabric={AW22.jackets.DropShoulderPUCoat.itemFabric}
//         />git commit -m

//         <SizeChart src={AW22.jackets.DropShoulderPUCoat.sizeChart} />

//         {/*         <div className="swiper-container" id="swiper">
//           <div className="swiper-wrapper">
//             {AW22.jackets.DropShoulderPUCoat.pictures.map(
//               ({ id, pictures }) => (
//                 <div className="swiper-slide">
//                   <img alt={AW22.alt} loading="lazy" src={pictures} key={id} />
//                 </div>
//               )
//             )}
//           </div>
//         </div> */}

//         <div className="swiper-container" id="swiper">
//           <div className="swiper-wrapper">
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.DropShoulderPUCoat.picture01}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.DropShoulderPUCoat.picture02}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.DropShoulderPUCoat.picture03}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.DropShoulderPUCoat.picture04}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.DropShoulderPUCoat.picture05}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//           </div>
//         </div>

//         <ShopifyMainComponent
//           divId={AW22.jackets.DropShoulderPUCoat.shopifyDivId}
//           mainId={AW22.jackets.DropShoulderPUCoat.shopifyId}
//         />
//         <SwiperInit />
//       </div>
//     );
//   }
// }

// export default DropShoulderPUCoat;

import React from "react";

import { AW22 } from "../../../../js/database/database-aw22.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const DropShoulderPUCoat = () => {
  return (
    <ProductsContainer
      pageTitle={AW22.jackets.DropShoulderPUCoat.itemName}
      name={AW22.jackets.DropShoulderPUCoat.itemName}
      price={AW22.jackets.DropShoulderPUCoat.itemPrice}
      fabric={AW22.jackets.DropShoulderPUCoat.itemFabric}
      src={AW22.jackets.DropShoulderPUCoat.sizeChart}
      divId={AW22.jackets.DropShoulderPUCoat.shopifyDivId}
      mainId={AW22.jackets.DropShoulderPUCoat.shopifyId}
    >
      {React.Children.toArray(
        AW22.jackets.DropShoulderPUCoat.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW22.jackets.DropShoulderPUCoat.itemName}
              width={AW22.imgWidth}
              height={AW22.imgHeight}
              loading={AW22.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default DropShoulderPUCoat;
